import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'forest' | 'earth' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'border border-amber-600 bg-amber-500 text-emerald-950 shadow-lg shadow-stone-900/20 hover:bg-amber-400',
    forest: 'bg-emerald-800 text-stone-50 shadow-lg hover:bg-emerald-700',
    earth: 'bg-stone-700 text-stone-50 shadow-lg hover:bg-stone-800',
    outline: 'border-2 border-emerald-800 bg-transparent text-emerald-900 hover:bg-emerald-800 hover:text-stone-50'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-8 sm:text-base'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-extrabold uppercase tracking-wide transition-[background-color,color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-300/60 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-261" data-mp="12nbsd0mi6ipq">
        {children}
        {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-262" data-mp="xpaauk4q6rgd" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-263" data-mp="1cdy4ulyxat47">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-264" data-mp="17fd2afw77xcl" />}
    </button>;
}